export function debounce(fn, delay = 0) {
    let id;
    return (...args) => {
        if (id !== undefined) {
            clearTimeout(id);
        }
        id = setTimeout(() => {
            fn(...args);
            id = undefined;
        }, delay);
    };
}
export function setZ(straightSegment, first, last) {
    const geometry = straightSegment.getGeometry();
    const coordinates = geometry.getCoordinates();
    console.assert(coordinates.length === 2);
    if (geometry.getLayout() === 'XY') {
        coordinates[0].push(first);
        coordinates[1].push(last);
    }
    else {
        coordinates[0][2] = first;
        coordinates[1][2] = last;
    }
    geometry.setCoordinates(coordinates);
    console.assert(geometry.getLayout() === 'XYZ');
}
export function isPoint(g) {
    return g?.getType() === 'Point';
}
export function isLineString(g) {
    return g?.getType() === 'LineString';
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnRlcmFjdGlvbi91dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE1BQU0sVUFBVSxRQUFRLENBQUMsRUFBMkIsRUFBRSxLQUFLLEdBQUcsQ0FBQztJQUM3RCxJQUFJLEVBQThDLENBQUM7SUFDbkQsT0FBTyxDQUFDLEdBQUcsSUFBUyxFQUFFLEVBQUU7UUFDdEIsSUFBSSxFQUFFLEtBQUssU0FBUyxFQUFFLENBQUM7WUFDckIsWUFBWSxDQUFDLEVBQUUsQ0FBQyxDQUFDO1FBQ25CLENBQUM7UUFDRCxFQUFFLEdBQUcsVUFBVSxDQUFDLEdBQUcsRUFBRTtZQUNuQixFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQztZQUNaLEVBQUUsR0FBRyxTQUFTLENBQUM7UUFDakIsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ1osQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUVELE1BQU0sVUFBVSxJQUFJLENBQUMsZUFBb0MsRUFBRSxLQUFhLEVBQUUsSUFBWTtJQUNwRixNQUFNLFFBQVEsR0FBRyxlQUFlLENBQUMsV0FBVyxFQUFFLENBQUM7SUFDL0MsTUFBTSxXQUFXLEdBQUcsUUFBUSxDQUFDLGNBQWMsRUFBRSxDQUFDO0lBQzlDLE9BQU8sQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDLE1BQU0sS0FBSyxDQUFDLENBQUMsQ0FBQztJQUN6QyxJQUFJLFFBQVEsQ0FBQyxTQUFTLEVBQUUsS0FBSyxJQUFJLEVBQUUsQ0FBQztRQUNsQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQzNCLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDNUIsQ0FBQztTQUFNLENBQUM7UUFDTixXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsS0FBSyxDQUFDO1FBQzFCLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUM7SUFDM0IsQ0FBQztJQUNELFFBQVEsQ0FBQyxjQUFjLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDckMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsU0FBUyxFQUFFLEtBQUssS0FBSyxDQUFDLENBQUM7QUFDakQsQ0FBQztBQUVELE1BQU0sVUFBVSxPQUFPLENBQUMsQ0FBVztJQUNqQyxPQUFPLENBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxPQUFPLENBQUM7QUFDbEMsQ0FBQztBQUVELE1BQU0sVUFBVSxZQUFZLENBQUMsQ0FBVztJQUN0QyxPQUFPLENBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxZQUFZLENBQUM7QUFDdkMsQ0FBQyJ9